import { HdButtonGroupModule } from './hd-button-group/hd-button-group.module';
import { HdButtonModule } from './hd-button/hd-button.module';

import { HdDetailFormModule } from './hd-detail-form/hd-detail-form.module';
import { HdDetailLinesModule } from './hd-detail-lines/hd-detail-lines.module';
import { HdDetailLinesPageModule } from './hd-detail-lines-page/hd-detail-lines-page.module';
import { HdDetailTipModule } from './hd-detail-tip/hd-detail-tip.module';

import { HdFilterModule } from './hd-filter/hd-filter.module';
import { HdFormLinesModule } from './hd-form-lines/hd-form-lines.module';
import { HdFormModule } from './hd-form/hd-form.module';

import { NgModule } from '@angular/core';
import { HdCurrentTableModule } from './hd-current-table/hd-current-table.module';
import { HdLogModule } from './hd-log/hd-log.module';
import { HdPopconfirmModule } from './hd-popconfirm/hd-popconfirm.module';
import { HdSpaceModule } from './hd-space/hd-space.module';
import { HdStatusModule } from './hd-status/hd-status.module';
import { HdTableModule } from './hd-table/hd-table.module';
import { HdTipModule } from './hd-tip/hd-tip.module';
import { HdAccessoryListModule } from './hd-accessory-list/hd-accessory-list.module';
import { HdOverlayCleanupService } from './service/hd-overlay-cleanup.service';
@NgModule({
  exports: [
    HdButtonModule,
    HdButtonGroupModule,

    HdDetailFormModule,
    HdDetailLinesModule,
    HdDetailLinesPageModule,
    HdDetailTipModule,

    HdFilterModule,
    HdFormModule,
    HdFormLinesModule,

    HdSpaceModule,
    HdStatusModule,
    HdCurrentTableModule,
    HdTableModule,
    HdTipModule,
    HdAccessoryListModule,
    HdPopconfirmModule,
    HdLogModule
  ]
})

export class HdComponentModule {
  // 单独引入 HdComponentModule 时也启动全局 tooltip 清理
  constructor(_overlayCleanup: HdOverlayCleanupService) {}
}
